// @flow

import React from "react";
import { connect } from "react-redux";
import Media from "react-media";
import bowser from "bowser";

// Common Components
import Header from "@src/components/Header";
import RootComponent from "@src/components/RootComponent";
import UnsupportedOnMobile from "@src/components/Unsupported/mobile";
import OutdatedBrowser from "@src/components/Unsupported/browser";

// Containers
import Landing from "@src/containers/Landing";
import Assessment from "@src/containers/Assessment";

class AppContainer extends React.Component {
  render() {
    const showAssessment = this.props.showAssessment;
    if (!bowser.check({ msie: "11", msedge: "11" })) {
      return <OutdatedBrowser />;
    }
    return (
      <Media query="(max-width: 640px)">
        {matches =>
          matches
            ? <UnsupportedOnMobile />
            : <RootComponent key="RootComponent">
                <Header key="Header" />
                {showAssessment ? <Assessment /> : <Landing />}
              </RootComponent>}
      </Media>
    );
  }
}

function mapStateToProps(store) {
  return {
    showAssessment: store.app.showAssessment
  };
}

export default connect(mapStateToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/index.jsx